import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "update-domain-language-modal" */'./UpdateDomainLanguageModal').then(mod => mod.default),
  LoadingComponent: () => null
});